import { NgModule, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID } from '@angular/core';
import { AppInsightsModule } from 'microsoft-applicationinsights-angular5';
import { EnvironmentNames } from '@src/environments/environments.name';
import { AppBaseModule } from '@src/base-components/app-base.module';
import { MessikaRoutingModule } from './messika-routing.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { HttpClient } from '@angular/common/http';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MultiTranslateHttpLoader } from '@src/core/MultiTranslateHttpLoader';
import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '@src/environments/environment';
import { PageLayoutComponent } from '@src/base-components/pagelayout/pagelayout.component';
import { PageLayoutMessikaComponent } from './pagelayout/pagelayout-messika.component';
import { NavbarMessikaComponent } from './navbar/navbar-messika.component';

import { MessikaComponent } from './messika.component';
import { LoginComponent } from '@src/auth/login.component';
import { PageHeaderComponent } from '@src/shared/page-header/page-header.component';
import { DashboardComponents } from '@src/base-components/dashboard/dashboard.components-container';
import { ActivationComponents } from '@src/base-components/activation/activation.components-container';
import { ActivationComponent } from './activation/activation.component';
import { ActivationConfirmationMessikaComponent } from './activation/steps/confirmation/activation-confirmation';
import { ActivationFindProductComponentMessika } from './activation/steps/find-product/activation-find-product';
import { ActivationSelectTypeComponentMessika } from './activation/steps/select-type/activation-select-type';
import { ActivationResultComponentMessika } from './activation/steps/result/activation-result';
import { ActivationFindWCComponentMessika } from './activation/steps/find-wc/activation-find-wc';
import { ActivationSelectRetailerComponentMessika } from './activation/steps/select-retailer/activation-select-retailer';
import { MessikaWarrantyCertificateComponent } from './warranty-certificate/warranty-certificate.component';
import { ProductOfMessikaComponent } from './product-of-messika/product-of-messika.component';
import { WizardFindSerializableProductComponentMessika } from './wizard/find-product/wizard-find-serializable-product';
import { WizardFindNotSerializableProductComponentMessika } from './wizard/find-product/wizard-find-not-serializable-product';
import { WizardFindProductItemsResultComponentMessika } from './wizard/find-product/wizard-find-product-items-result';
import { WizardFindProductsResultComponentMessika } from './wizard/find-product/wizard-find-products-result';
import { WizardSelectTypeComponentMessika } from './wizard/select-type/wizard-select-type';
import { WizardSelectRetailerComponentMessika } from './wizard/select-retailer/wizard-select-retailer';
import { WizardPreSelectedRetailerComponentMessika } from './wizard/select-retailer/wizard-pre-selected-retailer';
import { SaleDetailsCorrectionComponent } from './sales/sale-details/product/sale-details-correction.component';
import { SalesComponents } from '@src/base-components/sales/sales.components-container';
import { RetailersComponents } from '@src/base-components/retailers/retailers.components-container';
import { RetailerDetailsComponentMessika } from './retailers/retailer-details/retailer-details.component';
import { RetailerDetailsInfoComponentMessika } from './retailers/retailer-details/retailer-details-info/retailer-details-info.component';
import { SidebarMessikaComponent } from './sidebar/sidebarMessika.component';
import { ProfileComponent } from '@src/base-components/profile/profile.component';
import { ProfileComponentMessika } from './profile/profile.component';
import { ToastrModule } from 'ngx-toastr';
import { ToastCustomOptions } from './extra/toastr.custom-option';
import { PageNotFoundComponent } from '@src/shared/page-notfound.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { SaleDetailsProductMessikaComponent } from './sales/sale-details/product/sale-details-product.component';
import { FindUserByUsernameComponent } from '@src/base-components/users/find-user/find-user-username.component';
import { UserAccessRoleRules } from '@src/auth/user-access-roles-rules';
import { MessikaAccessRules } from './messika-access-rules';
import { AppSettings } from '@src/core/AppSettings';
import { PrivacyModalContentComponent } from '@src/base-components/privacy/privacy-modal-content.component';
import { ManagementComponents } from '@src/base-components/management/management.container';
import { ManagementMessikaComponents } from './management/management-messika.container';
import { UsersComponents } from '@src/base-components/users/users.container';
import { RepairsComponents } from '@src/base-components/repairs/repairs.container';
import { CustomersMessikaComponents } from './customers/customers.components-container';
import { InventoriesComponents } from '@src/base-components/inventories/inventories.components-container';
import { ExternalSearchMessikaComponent } from './external-search/external-search-messika.component';
import { SearchSaleDetailsComponent } from '@src/base-components/external-search/sale-details/sale-details.component';
import { FileUploadModule } from 'ng2-file-upload';
import { MessikaAppSettings } from './MessikaAppSettings';
import { ExternalSearchComponent } from '@src/base-components/external-search/external-search.component';
import { SaleDetailsWarrantiesMessikaComponent } from './sales/sale-details/warranties/sale-details-warranties.component';
import { QRCodePrintingComponents } from '@src/base-components/qr-code-printing/qrcodeprinting.components-container';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalReturnSaleMessikaComponent } from './sales/sale-details/return-sale/modal-return-sale.component';
import { ModalTheftComponent } from '@src/base-components/sales/sale-details/theft/modal-theft.component';
import { SaleDetailsMessikaComponent } from './sales/sale-details/sale-details.component';
import { SalesMessikaComponent } from './sales/sales.component';
import { InventoryItemAddSerialNumberComponent } from '@src/base-components/inventories/inventory-details/items-table/items-add-serial-number/items-add-serial-number';
import { InventoryItemDeleteSerialNumberComponent } from '@src/base-components/inventories/inventory-details/items-table/items-delete-serial-number/items-delete-serial-number';
import { WizardCreateSerialNumberComponent } from '@src/base-components/wizard/create-searial-number/wizard-create-serial-number.component';
import { ProductsComponents } from '@src/base-components/products/products.components-container';
import { SalesFilterComponent } from '@src/base-components/sales/filter/sales-filter.component';
import { ShipmentsComponents } from '@src/base-components/shipments/shipments.components-container';
import { UserDetailsMessikaComponent } from './users/user-details/user-details.component';
import { AssistanceComponent } from './assistance/assistance.component';
import { TermsComponent } from './terms/terms.component';
import { RecaptchaModule, RECAPTCHA_SETTINGS, RecaptchaSettings, RECAPTCHA_BASE_URL } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';

import { NgxScannerQrcodeModule } from "ngx-scanner-qrcode";

import { registerLocaleData } from '@angular/common';
import  localeEs from '@angular/common/locales/es';
import  localeFr from '@angular/common/locales/fr';
import  localeEn from '@angular/common/locales/en';
import  localeIt from '@angular/common/locales/it';
registerLocaleData(localeEs);
registerLocaleData(localeFr);
registerLocaleData(localeEn);
registerLocaleData(localeIt);

export function translateLoader(http: HttpClient) {
    return new MultiTranslateHttpLoader(http, [
        {
            prefix: '/locale/',
            suffix: '.json'
        }, {
            prefix: '/locale/custom/privacy.',
            suffix: '.json'
        }, {
            prefix: '/locale/custom/',
            suffix: '.json'
        }
    ]);
}

let instrumentationKey = '';
if (environment.envName === EnvironmentNames.prod) {
    instrumentationKey = '0b0f9723-36fd-4950-bbbe-e839ded444c9';
} else {
    instrumentationKey = '980f2ac3-0a71-4d60-85a7-cc13237cfa84'; //dev
}

@NgModule({
    imports: [
        AppBaseModule.forRoot(),
        AppInsightsModule.forRoot(instrumentationKey),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (translateLoader),
                deps: [HttpClient]
            }
        }),
        MessikaRoutingModule,
        NgxDatatableModule,
        NgxChartsModule,
        ToastrModule.forRoot(ToastCustomOptions),
        FileUploadModule,
        FormsModule,
        ReactiveFormsModule,
        RecaptchaModule,
        RecaptchaFormsModule,
        NgxScannerQrcodeModule
    ],
    declarations: [
        PageLayoutComponent,
        PageLayoutMessikaComponent,
        NavbarMessikaComponent,
        MessikaComponent,
        PrivacyModalContentComponent,
        PageHeaderComponent,
        PageNotFoundComponent,
        PrivacyComponent,
        ActivationComponent,
        ActivationConfirmationMessikaComponent,
        ActivationResultComponentMessika,
        ActivationSelectTypeComponentMessika,
        ActivationFindProductComponentMessika,
        ActivationFindWCComponentMessika,
        ActivationSelectRetailerComponentMessika,
        MessikaWarrantyCertificateComponent,
        ProductOfMessikaComponent,
        WizardFindSerializableProductComponentMessika,
        WizardFindNotSerializableProductComponentMessika,
        WizardFindProductItemsResultComponentMessika,
        WizardFindProductsResultComponentMessika,
        WizardSelectTypeComponentMessika,
        WizardSelectRetailerComponentMessika,
        WizardPreSelectedRetailerComponentMessika,
        TermsComponent,
        AssistanceComponent,
        LoginComponent,
        ProfileComponent,
        ProfileComponentMessika,
        SearchSaleDetailsComponent,
        FindUserByUsernameComponent,
        InventoryItemAddSerialNumberComponent,
        InventoryItemDeleteSerialNumberComponent,
        SaleDetailsCorrectionComponent,
        SidebarMessikaComponent,
        SaleDetailsProductMessikaComponent,
        ExternalSearchComponent,
        ExternalSearchMessikaComponent,
        SaleDetailsWarrantiesMessikaComponent,
        RetailerDetailsComponentMessika,
        RetailerDetailsInfoComponentMessika,
        ModalReturnSaleMessikaComponent,
        ModalTheftComponent,
        SaleDetailsMessikaComponent,
        SalesMessikaComponent,
        WizardCreateSerialNumberComponent,
        UserDetailsMessikaComponent,
        ...UsersComponents,
        ...ManagementComponents,
        ...ManagementMessikaComponents,
        ...ActivationComponents,
        ...SalesComponents,
        ...RetailersComponents,
        ...DashboardComponents,
        ...RepairsComponents,
        ...QRCodePrintingComponents,
        ...CustomersMessikaComponents,
        ...InventoriesComponents,
        ...ProductsComponents,
        ...ShipmentsComponents
    ],
    entryComponents: [PrivacyModalContentComponent, ModalReturnSaleMessikaComponent, ModalTheftComponent, SalesFilterComponent ],
    bootstrap: [MessikaComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        { provide: AuthConfig, useValue: environment.authConfig },
        { provide: UserAccessRoleRules, useClass: MessikaAccessRules },
        { provide: 'AuthService', useClass: environment.authServiceType },
        { provide: AppSettings, useClass: MessikaAppSettings },
        {
            provide: RECAPTCHA_SETTINGS,
            useValue: {
                siteKey: environment.siteKey,
            } as RecaptchaSettings,
        },
        {
            provide: RECAPTCHA_BASE_URL,
            useValue: 'https://recaptcha.net/recaptcha/api.js', // use recaptcha.net script source for some of our users
        }
    ]
})
export class MessikaModule { }
